import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as moment from "moment";
import {
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  withStyles,
  Button
} from "@material-ui/core";
import * as TransactionActions from "../../../store/TransactionStore";
import {
  DownloadTransactionFiles,
  DownloadTransactionErrorFile
} from "../../../services/transactionService";

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 1,
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  },
  filterLabel: {
    position: "relative",
    top: 1,
    marginRight: theme.spacing.unit * 1
  }
});

class TransactionHistoryApp extends Component {
  componentDidMount() {
    const { requestTransactionFiles } = this.props;
    requestTransactionFiles();
  }

  render() {
    const { classes, transactionFiles } = this.props;
    return (
      <div>
        <Typography variant="h4" gutterBottom component="h2">
          Transaction History
        </Typography>
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>File Name</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="center">Create Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transactionFiles.map(file => (
                <TableRow key={file.id}>
                  <TableCell component="th" scope="row">
                    <Button
                      onClick={() => {
                        DownloadTransactionFiles(file.id, file.fileName);
                      }}
                    >
                      {file.fileName}
                    </Button>
                  </TableCell>
                  <TableCell>
                    {file.transactionFileStatus.name}
                    {file.transactionFileStatusId === 4 && (
                      <Button
                        onClick={() => {
                          DownloadTransactionErrorFile(
                            file.id,
                            file.errorFileName
                          );
                        }}
                      >
                        errors
                      </Button>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {moment(file.createDateLocal).format("M/D/YYYY hh:mm:ss A")}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    transactionFiles: state.transactions.transactionFiles || []
  };
}

export default connect(
  mapStateToProps,
  dispatch =>
    bindActionCreators(
      Object.assign({}, TransactionActions.actionCreators),
      dispatch
    )
)(withStyles(styles)(TransactionHistoryApp));
